var _style, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner",
    width: "65px",
    height: "65px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    // Here is where the magic happens\n    \n  .spinner {\n    animation: rotator 1.4s ease-in-out infinite;\n  }\n  \n  @keyframes rotator {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(270deg); }\n  }\n  \n  .path {\n    stroke-dasharray: 187;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n    animation:\n      dash 1.4s ease-in-out infinite, \n      colors 5.6s ease-in-out infinite;\n  }\n  \n  @keyframes colors {\n    0% { stroke: #EB1E43; }\n    25% { stroke: #A11692; }\n    50% { stroke: #EB1E43; }\n    75% { stroke: #A11692; }\n    100% { stroke: #EB1E43; }\n  }\n  \n  @keyframes dash {\n   0% { stroke-dashoffset: 187; }\n   50% {\n     stroke-dashoffset: 46.75;\n     transform: rotate(135deg);\n   }\n   100% {\n     stroke-dashoffset: 187;\n     transform: rotate(720deg);\n   }\n  }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path",
    fill: "none",
    strokeWidth: 8,
    strokeLinecap: "round",
    cx: 33,
    cy: 33,
    r: 25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIndicator);
export default __webpack_public_path__ + "static/media/loading_indicator.9ba30ad1c5904a69ea8f32c0db4713bf.svg";
export { ForwardRef as ReactComponent };